import styled from 'styled-components';

import { PlaceBidButton } from 'src/components/PlaceBid/PlaceBid.style';
import { ShareBarContainer } from '@riac/design-system';

export const DetailPageShareContainer = styled.div`
  @media print {
    display: none;
  }

  ${ShareBarContainer} {
    margin-top: 0;
  }
`;

export const DetailPageActionAreaActions = styled.div`
  display: inline-block;
`;

export const DetailPageBidButtons = styled.div`
  display: flex;
  gap: 1em;
  ${PlaceBidButton} {
    font-size: 2.4rem;
    margin: 0;

  }
`;
